import { Avatar, Link, Stack, Typography } from '@mui/material';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useDictionary } from 'Hooks';
import { LeftArrow, PurpleOutlinedAlert } from 'Images';
import { useNavigate } from 'react-router-dom';

export const LinkToRequest = () => {
  const dictionary = useDictionary(Dictionary, DICTIONARY.Feedback);
  const navigate = useNavigate();

  return (
    <Stack
      direction={'row'}
      sx={{
        gap: '6px',
        alignItems: 'center',
      }}
    >
      <Avatar
        alt=''
        src={PurpleOutlinedAlert}
        sx={{ height: '24px', width: '24px' }}
      />
      <Typography variant='body6'>{dictionary.wantToReachOut}</Typography>
      <Link
        underline='none'
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
        }}
        onClick={() => navigate('/universalRequest')}
      >
        <Typography variant='body6'>{dictionary.sendRequest}</Typography>
        <Avatar alt='' src={LeftArrow} sx={{ height: '20px', width: '20px' }} />
      </Link>
    </Stack>
  );
};
